import {api} from '../../../shared';
import {ProjectStoriesFilter, ProjectStoriesResponse, CreateProjectStoryDTO, ProjectStoryModel} from '../model';

export interface EditProjectStoryDTO {
  date: string;
  title: string;
  priority: number;
}

export interface ProjectStoryDetailedModel extends ProjectStoryModel {
  screens: ProjectStoryScreenModel[];
}

export interface ProjectStoryMediaFileModel {
  fileName: string;
  // Базовое изображение (base@jpg) или файл видео
  url: string;
  // Превью экрана (story@webp) у изображений и постеров; у файла видео отсутствует
  thumbnailUrl?: string | null;
}

export interface ProjectStoryMediaImageModel {
  type: 'image';
  image: ProjectStoryMediaFileModel;
}

export interface ProjectStoryMediaVideoModel {
  type: 'video';
  video: ProjectStoryMediaFileModel;
  thumbnail?: ProjectStoryMediaFileModel;
}

export type ProjectStoryMediaModel = ProjectStoryMediaImageModel | ProjectStoryMediaVideoModel;

export interface ProjectStoryScreenModel {
  media?: ProjectStoryMediaModel | null;
  paragraphs: ProjectStoryParagraphModel[];
  alignToBottom: boolean;
  button: ProjectStoryButtonModel | null;
  theme: 'Light' | 'Dark';
}

export interface ProjectStoryParagraphModel {
  style: string;
  text: string;
}

export interface ProjectStoryButtonModel {
  text: string;
  link: string;
  theme: 'White' | 'Black' | 'Default';
}

export const projectStoriesApi = {
  getProjectStories: async (params: ProjectStoriesFilter = {}): Promise<ProjectStoriesResponse> => {
    const {data} = await api.get<ProjectStoriesResponse>('/api/content/admin/project/stories', {params});
    return data;
  },

  createProjectStory: async (story: CreateProjectStoryDTO): Promise<ProjectStoryModel> => {
    const {data} = await api.post<ProjectStoryModel>('/api/content/admin/project/stories', story);
    return data;
  },

  updateProjectStory: async (storyId: string, story: EditProjectStoryDTO): Promise<ProjectStoryModel> => {
    const {data} = await api.post<ProjectStoryModel>(`/api/content/admin/project/stories/${storyId}`, story);
    return data;
  },

  deleteProjectStory: async (storyId: string): Promise<void> => {
    await api.delete(`/api/content/admin/stories/${storyId}`);
  },

  getProjectStoryById: async (storyId: string): Promise<ProjectStoryDetailedModel> => {
    const {data} = await api.get<ProjectStoryDetailedModel>(`/api/content/admin/project/stories/${storyId}`);
    return data;
  },

  updateProjectStoryPreviewImage: async (storyId: string, previewImageUploadId: string): Promise<void> => {
    await api.post(`/api/content/admin/project/stories/${storyId}/preview-image`, {previewImageUploadId});
  },
};
